import BaseAPI from "@/api/BaseAPI";

export class FormAccreditationAPI extends BaseAPI{
    constructor() {
        super('/form4');
    }
    /**
     * @param {Number} id orgID
     * */
    read(id) {
        return this.http.get('/get', {data:{orgId: id}})
    }

    create(data) {
        return this.http.post('/set', {data})
    }

    update(data) {
        return this.http.post('/set', {data})
    }
    delete(identifier) {
        return this.http.delete('/delete', {data: {rowId : identifier}})
    }
}
export default new FormAccreditationAPI()